// extracted by mini-css-extract-plugin
module.exports = {"Title":"KioskShopList_Title__3J862","List":"KioskShopList_List__1IusC","GroupTitle":"KioskShopList_GroupTitle__31E0K","ShopGroup":"KioskShopList_ShopGroup__2ahov"};